export const COMPENSATION_OPERATIONS = [
    'compensation',
    'refund',
    'cancellation',
    'p2p',
] as const;

export type CompensationOperation = (typeof COMPENSATION_OPERATIONS)[number];
